import { EditRowComponent } from "../EditRowComponent";
import { WidgetTypes } from "../../../Widgets/WidgetTypes";
import { IWidgetContext } from "./IWidgetContext";
import { IWidgetLayout } from "../../../Server/IWidgetLayout";
import { WidgetController } from "../../../WidgetController";
import { app } from "../../../../../Frame/App";
import { IWidgetSettings } from "./IWidgetSettings";

export class WidgetContextFe implements IWidgetContext {

    handleEdit(editButtonId: string, frame: HTMLElement, context: IWidgetContext, widgetLayout: IWidgetLayout,
        controller: WidgetController, widgetSettings?: IWidgetSettings) {
        let editButton = document.getElementById(editButtonId);
        if (!widgetLayout.isFixed) {
            frame.appendChild(new EditRowComponent({ editButton: editButton, controller: controller, context: context, widgetSettings: widgetSettings }).render());
            controller.setEditButtonEvent(editButton);
        }
        else {
            if (editButton) {
                app.destroyDomElements(editButton);
            }
        }
    }

    renderWidgets = (editRowComponent: EditRowComponent): HTMLElement[] => {
        let result: HTMLElement[] = [];
        result.push(editRowComponent.renderSingleWidget(Resources['WidgetClient'].widgetTable, WidgetTypes.Table, "bars"));
        result.push(editRowComponent.renderSingleWidget(Resources['WidgetClient'].widgetAnalyse, WidgetTypes.Analyse, "chart-bar"));
        result.push(editRowComponent.renderSingleWidget(Resources['WidgetClient'].widgetText, WidgetTypes.Text, "text"));
        result.push(editRowComponent.renderSingleWidget(Resources['WidgetClient'].widgetMeasureText, WidgetTypes.MeasureText, "text"));
        result.push(editRowComponent.renderSingleWidget(Resources['WidgetClient'].widgetImage, WidgetTypes.Image, "image"));

        if (editRowComponent.props.widgetSettings.useLinks)
            result.push(editRowComponent.renderSingleWidget(Resources['WidgetClient'].widgetLinks, WidgetTypes.Links, "globe"));

        if (editRowComponent.props.widgetSettings.useOnline)
            result.push(editRowComponent.renderSingleWidget(Resources['WidgetClient'].widgetWhoIsOnline, WidgetTypes.WhoIsOnline, "users"));

        if (editRowComponent.props.widgetSettings.useLists)
            result.push(editRowComponent.renderSingleWidget(Resources['WidgetClient'].widgetLists, WidgetTypes.Lists, "list-alt"));

        if (editRowComponent.props.widgetSettings.useStatistic)
            result.push(editRowComponent.renderSingleWidget(Resources['WidgetClient'].widgetStatistic, WidgetTypes.Statistic, "chart-line"));

        result.push(editRowComponent.renderSingleWidget(Resources['WidgetClient'].widgetHasMeasures, WidgetTypes.HasMeasures, "search"));
        result.push(editRowComponent.renderSingleWidget(Resources['WidgetClient'].widgetNewestDocuments, WidgetTypes.NewestDocuments, "file"));

        //result.push(editRowComponent.renderSingleWidget(Resources['WidgetClient'].widgetDashboard, WidgetTypes.Dashboard, "tachometer-alt"));

        return result;
    };

}